import { ActiveSubscriptionsSummary } from '@features/subscriptions/components/active-subscriptions-summary';
import { ActiveSuite } from '@features/subscriptions/components/active-suite';
import { SubscriptionProducts } from '@features/subscriptions/components/subscription-products';
import { SubscriptionsProvider } from '@features/subscriptions/context/subscription-context';
import { FlexView } from '@goodfynd/ui';
import { addClassNames } from '@goodfynd/theme';

import type { SubscriptionsPageProps } from './types';

import classes from './SubscriptionsPage.module.css';

export const SubscriptionsPage = ({
  className,
  initialAddons,
}: SubscriptionsPageProps) => {
  return (
    <SubscriptionsProvider initialAddons={initialAddons}>
      <div className={addClassNames(classes.container, className)}>
        <FlexView className={classes['left-column']} gap={32} height="100%">
          <ActiveSuite />

          <SubscriptionProducts />
        </FlexView>

        <ActiveSubscriptionsSummary />
      </div>
    </SubscriptionsProvider>
  );
};
